import { PLACE_AND_UPDATE_ORDER } from '../actions/types';

const reducer = state => ({
  ...state,
  currentApiRequest: PLACE_AND_UPDATE_ORDER.request,
});

export default reducer;
